import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Handle scroll to toggle background/shadow
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu & scroll to top on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: '当院について', path: '/about' },
    { name: '診療案内', path: '/services' },
    { name: '施設紹介', path: '/facilities' },
    { name: '採用情報', path: '/recruit' },
    { name: 'お問い合わせ', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#FFFDE7] shadow-md' : 'bg-[#FFFDE7]'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <h1 className="text-xl sm:text-2xl font-bold text-[#F48FB1]">
              おかやま小児科クリニック
            </h1>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="px-3 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap text-[#4A4A4A] hover:bg-[#FCE4EC] hover:text-[#F48FB1]"
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:0860123456"
              className="ml-2 flex items-center gap-1.5 bg-[#F48FB1] hover:bg-[#EC407A] text-white px-4 py-2 rounded-full text-sm font-bold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-base"></i>
              086-012-3456
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            className="lg:hidden p-2 rounded-lg transition-colors text-[#4A4A4A] hover:bg-[#FCE4EC]"
            aria-label="メニュー"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span
                className={`block h-0.5 w-full transition-all bg-[#4A4A4A] ${
                  isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
                }`}
              ></span>
              <span
                className={`block h-0.5 w-full transition-all bg-[#4A4A4A] ${
                  isMobileMenuOpen ? 'opacity-0' : ''
                }`}
              ></span>
              <span
                className={`block h-0.5 w-full transition-all bg-[#4A4A4A] ${
                  isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
              ></span>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <div className="bg-[#FFFDE7] shadow-lg rounded-b-3xl">
          <div className="px-4 py-6 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block px-4 py-3 rounded-full text-[#4A4A4A] hover:bg-[#FCE4EC] hover:text-[#F48FB1] transition-colors whitespace-nowrap"
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:0860123456"
              className="flex items-center justify-center gap-2 mx-4 mt-4 bg-[#F48FB1] hover:bg-[#EC407A] text-white px-6 py-3 rounded-full text-base font-bold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              086-012-3456
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
